export const NeoDApiErrors={MALFORMED_INPUT:{type:'MALFORMED_INPUT',description:'Please check your input',data:null}};